import { JobRendererTheme } from "@pulsion/forms-designer-2";
import { theme } from "../../styles/theme";

export const rendererTheme: JobRendererTheme = {
  colors: {
    primary: "#7260CF",
    secondary: "#DA6294",
    modalHeader: "#1B2457",
  },
  fonts: [`${theme.typography.fontFamily} !important` as string],
  font: {
    primary: {
      family: `${theme.typography.fontFamily} !important`,
      color: "#333333",
    },
    secondary: {
      family: `${theme.typography.fontFamily} !important`,
      color: theme.palette.text.primary,
      size: "15px",
    },
  },
  button: {
    fontSize: "16px",
  },
  table: {
    marginBottom: "1.5rem",
    header: {
      color: theme.backgroundShades.grey,
      justification: "space-between",
      font: `${theme.typography.fontFamily} !important`,
      fontSize: "2.2rem",
      padding: "0.5rem",
    },
    headerRow: {
      font: `${theme.typography.fontFamily} !important`,
      fontSize: "15px",
      fontColor: "#333333",
      fontWeight: "normal",
      textAlign: "left",
      backgroundColor: theme.backgroundShades.grey,
    },
    cell: {
      font: theme.typography.fontFamily,
      fontSize: "15px",
      fontColor: theme.palette.text.primary,
      textAlign: "left",
      backgroundColor: "inherit",
    },
    createButton: {
      paddingRight: "10px",
    },
  },
  containers: {
    root: {
      boxShadow: "none",
      border: "none",
      borderRadius: "0",
    },
    section: {
      boxShadow: "none",
      border: "none",
      borderRadius: "0",
    },
  },
  saveButton: {
    root: {
      borderRadius: "0",
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: "white",
      color: theme.palette.primary.main,
      textTransform: "uppercase",
      boxShadow: "none",
    },
    hover: {
      boxShadow: "none",
    },
  },
  sectionColumns: {
    container: {
      borderTop: "1px solid #d8d8d8",
    },
    sectionDisplay: {
      marginTop: 0,
      borderLeft: "1px solid #d8d8d8",
    },
  },
  subsections: {
    all: {
      borderRadius: "0",
      borderColor: theme.border.primary,
      border: "none",
    },
    adjacent: {
      borderRadius: "0",
      borderColor: theme.border.primary,
      marginTop: "14px",
      backgroundColor: "transparent",
      border: "none",
    },
    container: {
      padding: "0 20px",
    },
    header: {
      padding: "20px",
      fontSize: "18px",
      backgroundColor: "transparent",
      textTransform: "uppercase",
      color: theme.palette.primary.main,
      fontWeight: "bold",
      lineHeight: "23px",
    },
    divider: {
      borderTop: "none",
      borderBottom: "none",
      margin: 0,
    },
  },
  sectionMenu: {
    selected: {
      oldSelected: {
        borderLeft: "none",
        borderTop: "none !important",
      },
      borderLeft: `1px solid ${theme.border.primary}`,
      borderTop: `4px solid ${theme.palette.primary.main} !important`,
    },
    header: {
      fontSize: "18px",
      textTransform: "uppercase",
      lineHeight: "23px",
      fontWeight: "bold !important",
      color: theme.palette.primary.main,
      padding: "20px",
      margin: "0",
    },
    container: {
      marginTop: "0 !important",
      padding: 0,
      border: "none !important",
      borderRadius: 0,
    },
    item: {
      root: {
        color: theme.palette.text.primary,
        border: `1px solid ${theme.border.primary}`,
        padding: "20px 15px",
        lineHeight: "21px",
        fontSize: "16px",
        maxWidth: "100%",
      },
      hover: {
        backgroundColor: theme.border.primary,
      },
    },
  },
  headers: {
    color: theme.palette.primary.main,
    fontWeight: "bold !important",
    textTransform: "uppercase",
    textAlign: "left",
    lineHeight: "23px",
    fontSize: "1.1428571428571428rem",
  },
  fields: {
    borderRadius: "0",
    border: `1px solid ${theme.border.primary}`,
    padding: "8px",
    background: theme.backgroundShades.grey,
  },
  submitButtonContainer: {
    position: "absolute",
    top: "20px",
    right: "20px",
    display: "inline-block",
    width: "auto",
  },
  buttons: {
    root: {
      borderRadius: "0",
      boxShadow: "none",
      color: theme.backgroundShades.white,
      backgroundColor: theme.palette.primary.main,
    },
    hover: {
      borderRadius: "0",
      boxShadow: "none",
      backgroundColor: theme.backgroundShades.white,
      color: theme.palette.primary.main,
    },
  },
  buttonSetControl: {
    root: {
      margin: "5px",
      backgroundColor: theme.palette.primary.main,
    },
    hover: {
      backgroundColor: "#7d003e6b",
    },
    selected: {
      backgroundColor: "#fbbd08",
    },
  },
  sectionContainer: {
    marginLeft: "0px",
    marginRight: "0px",
  },
};
